import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSession } from './session-context.js';

export function RouteGuard({
  children,
}: {
  readonly children: ReactNode;
}): JSX.Element {
  const { state } = useSession();
  const location = useLocation();

  if (state.kind === 'loading') {
    return <></>;
  }

  if (state.kind === 'cookie_session') {
    return <>{children}</>;
  }

  const reason = state.kind === 'expired' ? 'expired' : 'unauthenticated';
  const search = new URLSearchParams({
    from: location.pathname + location.search,
    reason,
  });
  return <Navigate to={{ pathname: '/login', search: `?${search.toString()}` }} replace />;
}
